import { storeToRefs } from "pinia";

import { useAppStore } from "@/stores/appStore";

const useApp = () => {
  const appStore = useAppStore();
  const { mode, isMainNavOpen } = storeToRefs(appStore);

  const setMode = (mode) => {
    appStore.setMode(mode);
  };

  return {
    // ACTIONS
    setMode,
    // STATE
    mode,
    isMainNavOpen,
  };
};

export default useApp;
